module.exports = __webpack_public_path__ + "assets/img/f3.64754b89.jpg";